import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { thirdPartyLayers } from '../Layers/thirdPartyLayers'
import MapStylesLegend from './MapStylesLegend'

import { showTab } from '../../../common/util'

// Redux
import { getThirdPartyLayer } from 'ducks/mapProperties'
import { getActiveRules } from 'ducks/styles'

// Legend Images
import landCoverLegendImg from '@/assets/layer-legends/land-cover'
import lbcsActivityLegendImg from '@/assets/layer-legends/lbcs-activity'
import populationDensityLegendImg from '@/assets/layer-legends/pop-density'
import populationGrowthLegendImg from '@/assets/layer-legends/pop-growth'
import housingAffordabilityLegendImg from '@/assets/layer-legends/housing-affordability'

const images = {
  'landuse-wms':           landCoverLegendImg,
  'lbcs-activity':         lbcsActivityLegendImg,
  'population_density':    populationDensityLegendImg,
  'population_growth':     populationGrowthLegendImg,
  'housing_affordability': housingAffordabilityLegendImg,
}

const MapLayerLegend = ({ handleClose, visible }) => {
  const currentThirdPartyLayer = useSelector(getThirdPartyLayer)
  const [isLegendVisible, setIsLegendVisible] = useState(false)
  const isLayersModalOpen = useSelector(state => state.mapControls.layersModalOpen)
  const activeRules = useSelector(getActiveRules)

  useEffect(() => {
    // derive from currentThirdPartyLayer
    if(currentThirdPartyLayer && images[currentThirdPartyLayer]) {
      setIsLegendVisible(true)
    } else if(!visible) {
      // only hide it if the prop isn't forcing it open
      setIsLegendVisible(false)
    }
  }, [currentThirdPartyLayer, visible])

  useEffect(() => {
    if(visible) {
      setIsLegendVisible(true)
    }
  }, [visible])
  const thirdPartyLayer =
    thirdPartyLayers.find((layer) => layer.id === currentThirdPartyLayer) || {}

  const legendHeadline =
    currentThirdPartyLayer === 'lbcs-activity'
      ? 'LBCS Activity'
      : thirdPartyLayer?.name ?? ''

  const getLegendStyles = () => {
    const baseRight = isLayersModalOpen ? 565 : 60
    const screenRight = window.innerWidth < 768 ? 10 : baseRight
    return {
      display: isLegendVisible ? 'flex' : 'none',
      right:   `${screenRight}px`,
    }
  }

  const selectedImg = currentThirdPartyLayer && images[currentThirdPartyLayer]

  const openStylesTab = (e) => {
    e.preventDefault()
    e.stopPropagation()
    showTab('#map-nav-style')
  }

  return (
    <div
      style={getLegendStyles()}
      className="layers-legend rounded-lg shadow-gl padded-lg medium"
    >
      <div className='map-options-title-row padding-top-lg'>
      <h3 className='map-options-title'>Legend</h3>
        <div className="close" onClick={handleClose}>
          <i className="pull-right fa fa-times"></i>
        </div>
      </div>
      {visible && <MapStylesLegend />}
      {legendHeadline &&
      <><div className="map-options-title-row padding-top-lg">
          <h4 className="map-options-title">{legendHeadline} Legend</h4>
        </div><img src={selectedImg} alt="Legend" /></>
      }
      {(!activeRules || activeRules.length === 0) && !legendHeadline &&
            <><div className="padding-top-lg">
            <h4 className='map-options-title-row'>No style rules applied yet.</h4>
            <span className='map-options-title'>
            <a href="#" onClick={openStylesTab}> Add a style rule,</a> and you will see it here.</span>
          </div></>}
    </div>

  )
}

MapLayerLegend.propTypes = {
  handleClose: PropTypes.func.isRequired,
  visible:     PropTypes.bool,
}

export default MapLayerLegend
